import React from "react";
import "./homescreen.css"
import HomeHeaderCardsComponent, {HomeHeaderCard} from "./components/headercards/HomeHeaderCardsComponent";
import {HomeStandaloneTextComponent} from "./components/standalonetext/HomeStandaloneTextComponent";
import HomeCardComponent, {HomeCardType, ThemeColor} from "./components/homecard/HomeCardComponent";
import {Paths} from "../app/components/sidebar/Paths";
import {
    HomeCardSectionComponent,
    HomeCardSectionTextPlacement
} from "./components/homecardsection/HomeCardSectionComponent";
import {HomeHeaderComponent} from "./components/homeheader/HomeHeaderComponent";
import DataStructuresNavIcon from "../app/assets/DataStructuresNavIcon";
import InterviewTipsNavIcon from "../app/assets/InterviewTipsNavIcon";

export default function HomeScreen() {
    return (
        <div className="homeScreen">
            <HomeHeaderComponent/>
            <HomeHeaderCardsComponent>
                <HomeHeaderCard icon={<DataStructuresNavIcon/>}
                                title="Learn Data Structures"
                                link={Paths.dataStructures.nested.array.path}
                                color={ThemeColor.Secondary}/>
                <HomeHeaderCard icon={<InterviewTipsNavIcon/>}
                                title="Interview Tips & Tricks"
                                link={Paths.interviewTips.nested.general.path}
                                color={ThemeColor.Primary}/>
            </HomeHeaderCardsComponent>
            <HomeStandaloneTextComponent title="Your one-stop shop for passing the coding interview.">
                <p>With new content published regularly, this is the best place to learn about interview tips, data
                    structures, algorithms, and more.</p>
                <p>Whether you’re a beginner, or just need to brush up on topics, we’ve got you covered.</p>
                <p className="homeEmphasizedText">Content is always 100% free</p>
            </HomeStandaloneTextComponent>
            <HomeCardSectionComponent title={Paths.dataStructures.name}
                                      homeCardSectionTextPlacement={HomeCardSectionTextPlacement.End}
                                      highlightBackground={true}
                                      description="The building blocks of writing code. Learn the different ways of storing and organizing data to build optimized solutions when writing code.">
                <HomeCardComponent homeCardType={HomeCardType.Filled}
                                   color={ThemeColor.Secondary}
                                   path={Paths.dataStructures.nested.stack}/>
                <HomeCardComponent homeCardType={HomeCardType.Filled}
                                   color={ThemeColor.Primary}
                                   path={Paths.dataStructures.nested.hashmap}/>
                <HomeCardComponent homeCardType={HomeCardType.Filled}
                                   color={ThemeColor.Tertiary}
                                   path={Paths.dataStructures.nested.queue}/>
            </HomeCardSectionComponent>
            <HomeCardSectionComponent title={Paths.interviewTips.name}
                                      homeCardSectionTextPlacement={HomeCardSectionTextPlacement.Top}
                                      description={<p>Learn how best to prepare for technical software engineering
                                          interviews. From how to make your resume stand out all the way to matching
                                          with a team, find tips and tricks that will help you during your interview
                                          process.</p>}>
                <HomeCardComponent homeCardType={HomeCardType.Outlined}
                                   showAllNine={true}
                                   color={ThemeColor.Primary}
                                   path={Paths.interviewTips.nested.general}/>
                <HomeCardComponent homeCardType={HomeCardType.Outlined}
                                   showAllNine={true}
                                   color={ThemeColor.Tertiary}
                                   path={Paths.interviewTips.nested.resume}/>
                <HomeCardComponent homeCardType={HomeCardType.Outlined}
                                   showAllNine={true}
                                   color={ThemeColor.Secondary}
                                   path={Paths.interviewTips.nested.mobileSystemDesign}/>
            </HomeCardSectionComponent>
        </div>
    );
}
